
import ArrowLeft from "@/components/icons/ArrowLeft.vue";
import ArrowDown from "@/components/icons/ArrowDown.vue";
// import ThrashIcon from "@/components/icons/ThrashIcon.vue";
import { mapGetters, mapMutations } from "vuex";
import { yearBrackets } from "@/cars/utils";
import { defineComponent, PropType } from "vue";
import { Car } from "@/cars/types";

interface CarDetailsForSelectionData {
  expandableDetails: Boolean;
}

export default defineComponent({
  props: {
    car: Object as PropType<Car>,
  },
  data(): CarDetailsForSelectionData {
    return {
      expandableDetails: false,
    };
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar"]),
  },
  methods: {
    ...mapMutations("cars", ["setSelectedCar"]),
    expandDetailsTable() {
      this.expandableDetails = !this.expandableDetails;
    },
    changeCar(car: Car) {
      this.setSelectedCar(car);
      this.$emit("carChanged");
    },
    yearBrackets,
  },
  components: {
    ArrowLeft,
    ArrowDown,
    // ThrashIcon,
  },
});
